<template>
  <nav class="block">
    <router-link class="title" to="/">onboard2</router-link>
    <button class="logout" v-if="isAuthenticated" @click="logout">
      <font-awesome-icon icon="sign-out-alt" />
      <span>ログアウト</span>
    </button>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Cookies from 'js-cookie';

export default defineComponent({
  name: 'Nav',
  data() {
    return {
      isAuthenticated: false,
    };
  },
  async mounted() {
    this.isAuthenticated = this.checkAuthenticated();
  },
  methods: {
    checkAuthenticated() {
      return !!Cookies.get('accessToken');
    },
    async logout() {
      try {
        Cookies.remove('accessToken');
        Cookies.remove('refreshToken');
        this.$router.push('auth/login');
      } catch (error) {
        console.warn('Logout API failed:', error);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/assets/const.scss' as *;

.block {
  z-index: 2;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  width: 100%;
  padding: 10px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  box-shadow: 0 0 10px var(--bs-gray-400);
  background-color: var(--bs-white);
  @media (min-width: $desktop) {
    justify-content: flex-start;
    padding: 10px 40px;
  }

  .title {
    padding: 5px;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 4px;
    font-weight: bold;
    color: inherit;
  }

  .logout {
    position: absolute;
    display: flex;
    align-items: flex-end;
    right: 10px;
    margin-left: auto;
    padding: 0 5px;
    @media (min-width: $tablet) {
      right: 20px;
    }
    @media (min-width: $desktop) {
      position: static;
    }

    span {
      order: -1;
      display: none;
      margin-right: 5px;
      font-size: 0.9rem;
      @media (min-width: $tablet) {
        display: block;
      }
    }
  }
}
</style>
